function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeDasharray: "0 6",
  strokeLinecap: "round",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#B0BEC5",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.451 1.319L4.451 13.479",
  transform: "translate(-24.000000, -180.000000) translate(5.000000, 143.000000) translate(10.000000, 12.000000) translate(4.000000, 4.000000) translate(3.000000, 22.000000)"
}))))));
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.0a3bd2580d971731a0625a8bacb92386.svg";
export { ForwardRef as ReactComponent };